const translations: Record<string, string> = {
  // Navigation
  "nav.dashboard": "डैशबोर्ड",
  "nav.reception": "रिसेप्शन",
  "nav.bookings": "बुकिंग",
  "nav.inventory": "इन्वेंटरी",
  "nav.canteen": "कैंटीन",
  "nav.users": "यूज़र्स",
  "nav.expenses": "खर्च",
  "nav.housekeeping": "हाउसकीपिंग",
  "nav.audit": "नाइट ऑडिट",
  "nav.rates": "रेट कैलेंडर",

  // Dashboard
  "dashboard.title": "आपका स्वागत है",
  "dashboard.subtitle": "आज आपके होटल में क्या हो रहा है।",
  "dashboard.rooms": "कुल कमरे",
  "dashboard.checkins": "आज के चेक-इन",
  "dashboard.revenue": "आज का राजस्व",
  "dashboard.pending": "बकाया भुगतान",

  // Reception
  "reception.checkin": "चेक-इन",
  "reception.checkout": "चेक-आउट",
  "reception.billing": "बिलिंग",
  "reception.shifts": "शिफ्ट्स",

  // Bookings
  "bookings.new": "नई बुकिंग",
  "bookings.manage": "बुकिंग प्रबंधित करें",
  "bookings.rooms": "कमरे",
  "bookings.guests": "अतिथि",
  "bookings.billing": "GST बिलिंग",

  // Common
  "common.search": "खोजें",
  "common.save": "सहेजें",
  "common.cancel": "रद्द करें",
  "common.delete": "हटाएं",
  "common.edit": "संपादित करें",
  "common.close": "बंद करें",
  "common.confirm": "पुष्टि करें",
  "common.back": "वापस",
  "common.next": "आगे",
  "common.loading": "लोड हो रहा है...",
  "common.noData": "कोई डेटा नहीं",
  "common.all": "सभी",
  "common.total": "कुल",
  "common.amount": "राशि",
  "common.status": "स्थिति",
  "common.date": "तारीख",
  "common.action": "कार्रवाई",

  // Payment
  "payment.cash": "नकद",
  "payment.card": "कार्ड",
  "payment.upi": "UPI",
  "payment.online": "ऑनलाइन",
  "payment.method": "भुगतान विधि",
  "payment.received": "भुगतान प्राप्त",
  "payment.pending": "भुगतान बकाया",
  "payment.refund": "रिफंड",

  // Status
  "status.checked_in": "चेक-इन",
  "status.checked_out": "चेक-आउट",
  "status.confirmed": "पुष्टि",
  "status.cancelled": "रद्द",
  "status.pending": "लंबित",
  "status.completed": "पूर्ण",
  "status.in_progress": "प्रगति में",

  // Expenses
  "expenses.title": "दैनिक खर्च",
  "expenses.add": "खर्च जोड़ें",
  "expenses.category": "श्रेणी",
  "expenses.total": "कुल खर्च",

  // Housekeeping
  "housekeeping.title": "हाउसकीपिंग",
  "housekeeping.newTask": "नया कार्य",
  "housekeeping.priority": "प्राथमिकता",
  "housekeeping.high": "उच्च",
  "housekeeping.medium": "मध्यम",
  "housekeeping.low": "निम्न",

  // GST
  "gst.title": "GST बिलिंग",
  "gst.invoice": "GST इनवॉइस",
  "gst.proforma": "प्रोफ़ॉर्मा",
  "gst.deposit": "अग्रिम जमा",

  // Refund
  "refund.title": "रिफंड प्रोसेस",
  "refund.amount": "रिफंड राशि",
  "refund.method": "रिफंड विधि",
  "refund.note": "रिफंड नोट",

  // Audit
  "audit.title": "नाइट ऑडिट",
  "audit.revenue": "राजस्व",
  "audit.occupancy": "अधिभोग",
  "audit.checkins": "चेक-इन",
  "audit.checkouts": "चेक-आउट",

  // Rates
  "rates.title": "रेट कैलेंडर",
  "rates.season": "सीज़न",
  "rates.weekday": "सप्ताह दिन",
  "rates.weekend": "सप्ताहांत",
};

export default translations;